import React from 'react';
import { FlaskConicalIcon, UsersIcon, BadgeCheckIcon, BrainCircuitIcon, BarChart3Icon, SmartphoneIcon, HeadsetIcon, CheckCircle2Icon } from 'lucide-react';
export function SocialValidation() {
  const stats = [{
    value: '437',
    label: 'Participantes evaluados',
    icon: <UsersIcon className="w-5 h-5" data-id="element-88" />
  }, {
    value: '96%',
    label: 'Reportaron resultados positivos',
    icon: <BarChart3Icon className="w-5 h-5" data-id="element-89" />
  }, {
    value: '17',
    label: 'Técnicas validadas científicamente',
    icon: <BadgeCheckIcon className="w-5 h-5" data-id="element-90" />
  }, {
    value: '3 años',
    label: 'De investigación aplicada',
    icon: <BrainCircuitIcon className="w-5 h-5" data-id="element-91" />
  }];
  return <section className="py-12 bg-surface-elevated relative overflow-hidden" data-id="element-92">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-electric/5 rounded-full blur-[100px] pointer-events-none" data-id="element-93"></div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-94">
        <div className="text-center mb-10" data-id="element-95">
          <div className="inline-flex items-center px-4 py-2 rounded-full border border-electric/30 bg-electric/10 text-electric text-sm font-bold tracking-wider uppercase mb-6" data-id="element-96">
            <FlaskConicalIcon className="w-4 h-4 mr-2" data-id="element-97" />
            Respaldado por la Ciencia
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-98">
            Validado por un equipo de{' '}
            <span className="text-electric" data-id="element-99">investigadores</span> en psicología
            social
          </h2>
          <p className="font-body text-gray-400 text-lg max-w-3xl mx-auto leading-relaxed" data-id="element-100">
            Un grupo de psicólogos y especialistas en comportamiento humano de
            universidades latinoamericanas evaluaron y refinaron estas técnicas
            durante más de 3 años, aplicándolas en un estudio con{' '}
            <span className="text-white font-semibold" data-id="element-101">
              más de 400 personas
            </span>{' '}
            de distintos perfiles — desde introvertidos extremos hasta personas
            con ansiedad social.
          </p>
        </div>

        {/* Scientists image */}
        <div className="mb-12 rounded-2xl overflow-hidden border border-surface-border max-w-2xl mx-auto shadow-2xl" data-id="element-102">
          <img src="https://cdn.magicpatterns.com/uploads/iLKdRVMMBzmuviSJu6XWTQ/cientificos_mexico.png" alt="Equipo de investigadores en psicología social que validaron las 17 técnicas del Protocolo del Carisma" className="w-full h-auto object-cover" data-id="element-103" />
          <div className="bg-surface-card px-6 py-3 border-t border-surface-border" data-id="element-104">
            <p className="font-body text-sm text-gray-400 text-center italic" data-id="element-105">
              Equipo de investigación en Psicología Social Aplicada —
              Universidad Autónoma, 2024
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12" data-id="element-106">
          {stats.map((stat, index) => <div key={index} className="bg-surface-card border border-surface-border rounded-xl p-6 text-center hover:border-electric/30 transition-colors" data-id="element-107">
              <div className="inline-flex items-center justify-center w-10 h-10 bg-electric/10 text-electric rounded-lg mb-3" data-id="element-108">
                {stat.icon}
              </div>
              <p className="font-heading text-3xl md:text-4xl font-bold text-white mb-1" data-id="element-109">
                {stat.value}
              </p>
              <p className="font-body text-sm text-gray-400" data-id="element-110">{stat.label}</p>
            </div>)}
        </div>

        <div className="bg-surface-card border border-electric/20 rounded-2xl p-8 md:p-10 shadow-xl mb-16" data-id="element-111">
          <div className="flex flex-col md:flex-row items-start gap-6" data-id="element-112">
            <div className="bg-electric/10 p-4 rounded-xl flex-shrink-0" data-id="element-113">
              <FlaskConicalIcon className="w-10 h-10 text-electric" data-id="element-114" />
            </div>
            <div data-id="element-115">
              <h3 className="font-heading text-xl md:text-2xl font-bold text-white mb-3" data-id="element-116">
                Conclusión del estudio
              </h3>
              <p className="font-body text-gray-300 leading-relaxed mb-4" data-id="element-117">
                "Las 17 técnicas demostraron un impacto significativo en la
                percepción social de los participantes. El{' '}
                <span className="text-electric font-bold" data-id="element-118">
                  96% de los evaluados
                </span>{' '}
                reportó mejoras medibles en su capacidad de generar conexiones,
                mantener conversaciones con confianza y ser percibidos como
                personas más interesantes y seguras en contextos sociales."
              </p>
              <p className="font-body text-sm text-gray-500 italic" data-id="element-119">
                — Estudio de Dinámicas Sociales y Percepción Interpersonal,
                2024. Equipo de investigación en Psicología Social Aplicada.
              </p>
            </div>
          </div>
        </div>

        {/* --- DELIVERABLES / OFFER STACK SECTION --- */}
        <div className="pt-10 border-t border-surface-border" data-id="element-120">
          <div className="text-center mb-12" data-id="element-121">
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-122">
              ¿Qué recibes <span className="text-gold" data-id="element-123">exactamente?</span>
            </h2>
            <p className="font-body text-gray-400 text-lg" data-id="element-124">
              Todo lo que necesitas para transformar tu presencia, empaquetado y
              listo para aplicar.
            </p>
          </div>

          <div className="flex flex-col lg:flex-row gap-12 items-center mb-16" data-id="element-125">
            <div className="lg:w-1/2 relative" data-id="element-126">
              <div className="absolute -top-6 -right-6 bg-gold text-surface-deepest font-heading font-bold text-lg px-6 py-2 rounded-full shadow-xl z-20 transform rotate-12 border-2 border-surface-deepest" data-id="element-127">
                Libro Digital
              </div>
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] bg-gold/10 rounded-full blur-[80px] pointer-events-none z-0" data-id="element-128"></div>
              <img src="https://cdn.magicpatterns.com/uploads/19wgf3diFUjrZZ92hQg9WE/e4f93d4d-a72a-46ff-ba17-06b72aa6722c.png" alt="Libro Digital Carisma al Instante" className="w-full max-w-md mx-auto relative z-10 drop-shadow-2xl rounded-lg" data-id="element-129" />
            </div>

            <div className="lg:w-1/2 space-y-6" data-id="element-130">
              <div className="bg-surface-card p-6 rounded-2xl border border-gold/30" data-id="element-131">
                <h3 className="font-heading text-2xl font-bold text-white mb-2" data-id="element-132">
                  Manual Principal: Carisma al Instante
                </h3>
                <p className="font-body text-gray-400 mb-4" data-id="element-133">
                  El protocolo completo con los 17 trucos mentales explicados
                  paso a paso para que los apliques hoy mismo.
                </p>
                <ul className="space-y-2" data-id="element-134">
                  <li className="flex items-center text-gray-300 font-body text-sm" data-id="element-135">
                    <CheckCircle2Icon className="w-4 h-4 text-gold mr-2" data-id="element-136" />{' '}
                    Lectura de lenguaje corporal
                  </li>
                  <li className="flex items-center text-gray-300 font-body text-sm" data-id="element-137">
                    <CheckCircle2Icon className="w-4 h-4 text-gold mr-2" data-id="element-138" />{' '}
                    Técnicas de contacto visual
                  </li>
                  <li className="flex items-center text-gray-300 font-body text-sm" data-id="element-139">
                    <CheckCircle2Icon className="w-4 h-4 text-gold mr-2" data-id="element-140" />{' '}
                    Posicionamiento de alto valor
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* BONUSES */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-141">
            {/* Bonus 1 */}
            <div className="bg-surface-card border border-gold/40 rounded-2xl p-8 relative overflow-hidden shadow-xl shadow-gold/5 group flex flex-col" data-id="element-142">
              <div className="absolute top-0 right-0 bg-gold text-surface-deepest font-bold text-xs px-4 py-1 rounded-bl-lg z-10" data-id="element-143">
                ¡BONO GRATIS!
              </div>

              <div className="flex items-start gap-4 relative z-10 mb-8" data-id="element-144">
                <div className="bg-surface-elevated p-3 rounded-xl border border-gold/20 flex-shrink-0 relative" data-id="element-145">
                  <SmartphoneIcon className="w-8 h-8 text-gold" data-id="element-146" />
                  <div className="absolute inset-0 border border-gold rounded-xl animate-ping opacity-20" data-id="element-147"></div>
                </div>
                <div data-id="element-148">
                  <p className="text-gold font-bold text-sm tracking-widest uppercase mb-1" data-id="element-149">
                    Bono Exclusivo
                  </p>
                  <h3 className="font-heading text-2xl font-bold text-white mb-3 leading-tight" data-id="element-150">
                    ¿Cómo transmitir carisma por redes sociales?
                  </h3>
                  <p className="font-body text-gray-400 leading-relaxed" data-id="element-151">
                    Cómo proyectar un carisma magnético y autoridad sin decir
                    una sola palabra en persona. Resuelve el 50% del problema:
                    tu vida digital y cómo te perciben antes de conocerte.
                  </p>
                </div>
              </div>

              <div className="relative z-10 mt-auto rounded-xl overflow-hidden border border-surface-border shadow-lg" data-id="element-152">
                <img src="https://cdn.magicpatterns.com/uploads/1bDCUt1Kr9mss15pBVWseJ/bono_redes.png" alt="Bono Redes Sociales" className="w-full h-auto object-cover hover:scale-105 transition-transform duration-500" data-id="element-153" />
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="bg-[#1A1A1A] border border-surface-border rounded-2xl p-8 relative overflow-hidden shadow-xl bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] group flex flex-col" data-id="element-154">
              <div className="absolute top-0 right-0 bg-white text-black font-bold text-xs px-4 py-1 rounded-bl-lg z-10 flex items-center" data-id="element-155">
                <HeadsetIcon className="w-3 h-3 mr-1" data-id="element-156" /> ¡BONO GRATIS!
              </div>

              <div className="flex items-start gap-4 relative z-10" data-id="element-157">
                <div className="bg-black/50 p-3 rounded-xl border border-white/10 flex-shrink-0" data-id="element-158">
                  <BadgeCheckIcon className="w-8 h-8 text-white" data-id="element-159" />
                </div>
                <div data-id="element-160">
                  <p className="text-gray-400 font-bold text-sm tracking-widest uppercase mb-1" data-id="element-161">
                    Bono de Élite
                  </p>
                  <h3 className="font-heading text-2xl font-bold text-white mb-3 leading-tight" data-id="element-162">
                    Acompañamiento personalizado para tu caso
                  </h3>
                  <p className="font-body text-gray-300 leading-relaxed" data-id="element-163">
                    No estás solo. Resolvemos tus dudas, desbloqueamos tus
                    trabas y personalizamos el protocolo a TU situación real.
                    Línea directa con el especialista.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}